import layout from '@/components/layout/layout.vue'
import config from '@/config/base-config'
import demoRoute from './demo'      //示例文档路由

import authRoute  from './auth'

/**
 * path: string, component: (function()),
 * meta: {
 * hideInMenu: boolean, 设为true后在左侧菜单不会显示该页面选项
 * icon: string, 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线_
 * notCache: boolean, 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 * href: string,跳转外部链接
 * title: string,显示在侧边栏、面包屑和标签栏的文字
 * nodeID: number,可访问该页面的权限ID，当前路由设置的权限会影响子路由
 * },
 * name: string}
 */


const homeRoute = {
  path: '/home',
  name: 'home',
  meta: {
    // hideInMenu: true,
    title: '工作台',
    notCache: true,
    icon: 'md-home'
  },
  component: () => import('@/view/home/home.vue')
};

const route404 = [{
  path: '*',
  component: layout,
  hideInMenu: true,
  name:'',
  meta:{
    hideInMenu: true
  },
  children:[{
    name:'404',
    path:'*',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }]
}];

let routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      hideInMenu: true,
      title: '登陆',
      notCache: true,
      icon: '',
      href: '',
      nodeID: 0,
    },
    component: () => import('@/view/system/login/login.vue')
  },
  // / 根路由由 dealAuthRoute 动态添加，根据 groupID 决定首页
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  // {
  //   path: '/document',
  //   name: 'document',
  //   meta: {
  //     title: '操作菜单',
  //   },
  //   component: () => import('@/view/company/document.vue')
  // },
];




// routes = routes.concat(authRoute)

if (config.SHOW_DEMO){
  routes = routes.concat(demoRoute)
}


//头部菜单
const headMenu = [
  {
    
  path: '*',
  //  redirect: '/document',
  component: layout,
  // hideInMenu: true,
  name:'操作手册',
  meta:{
    hideInMenu: true
  },
  children:[{
    name:'操作手册 ',
    path:'/document',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/company/document.vue')
  }]
}
];

export {
  route404,
  routes,
  homeRoute,
  headMenu
  
}


